import { STATUS_SLUG } from '../invoice-copy'

const STATUSES = new Set([...Object.keys(STATUS_SLUG), 'refunded'])

export interface InvoicesSearch {
  q?: string
  statuses?: string
  sort?: 'newest' | 'oldest'
}

export function validateInvoicesSearch(
  raw: Record<string, unknown>,
): InvoicesSearch {
  const statuses =
    typeof raw.statuses === 'string'
      ? [
          ...new Set(
            raw.statuses.split(',').filter((value) => STATUSES.has(value)),
          ),
        ]
      : []
  return {
    q:
      typeof raw.q === 'string' && raw.q.trim() && raw.q.length <= 100
        ? raw.q
        : undefined,
    statuses: statuses.length ? statuses.join(',') : undefined,
    sort: raw.sort === 'oldest' || raw.sort === 'newest' ? raw.sort : undefined,
  }
}
